import React from 'react';
import classNames from 'classnames';
import { Tabs } from 'src/common/form/tabs';
import OrganizationLink from 'src/common/OrganizationLink';
import { functionNoop } from 'src/utils/function/noop';
import { DashboardInsightsJourneysTabType } from '../constants';

type Props = {
  journeyUuid: string;
  activeTab: DashboardInsightsJourneysTabType;
};

export const DashboardInsightsJourneysJourneyTabs = ({ journeyUuid, activeTab }: Props) => {
  return (
    <Tabs
      theme='bedrock'
      value={activeTab}
      onChange={functionNoop}
      options={[
        {
          value: 'steps',
          label: (
            <OrganizationLink to={`/insights/journeys/${journeyUuid}/steps`} className='flex'>
              Steps within Journey
            </OrganizationLink>
          ),
        },
        {
          value: 'visitor-sessions',
          label: (
            <OrganizationLink to={`/insights/journeys/${journeyUuid}/visitor-sessions`} className='flex'>
              Visitor sessions
            </OrganizationLink>
          ),
        },
        {
          value: 'chatbot-sessions',
          label: (
            <OrganizationLink to={`/insights/journeys/${journeyUuid}/chatbot-sessions`} className='flex'>
              <div className="flex items-center space-x-1">
                <span>Chatbot sessions</span>
                <span
                  className={classNames('rounded-lg p-1', {
                    'bg-bedrock-brand-primary text-white': activeTab !== 'chatbot-sessions',
                  })}
                  style={{
                    fontSize: '9px',
                    lineHeight: '9px',
                    fontWeight: '700',
                  }}
                >
                  NEW
                </span>
              </div>
            </OrganizationLink>
          ),
        },
      ]}
    />
  );
};
